function isHindiText(text) {
  return /[\u0900-\u097F]/.test(String(text || ""));
}

export function createIndianSpeechUtterance(text) {
  const content = String(text || "");
  const language = isHindiText(content) ? "hi-IN" : "en-IN";
  const utterance = new SpeechSynthesisUtterance(content);
  const voices = window.speechSynthesis?.getVoices?.() || [];
  const normalizedLanguage = language.toLowerCase();

  // Prefer a locally installed Indian voice, then any matching Indian locale voice.
  const voice = voices.find((item) => item.lang?.toLowerCase() === normalizedLanguage)
    || voices.find((item) => item.lang?.toLowerCase().startsWith(normalizedLanguage.slice(0, 2)) && /india|indian|in-/i.test(`${item.name} ${item.lang}`));

  utterance.lang = language;
  if (voice) utterance.voice = voice;
  return utterance;
}

function splitByScript(text) {
  return String(text || "")
    .match(/[\u0900-\u097F]+(?:[\s\d.,!?;:()'"-]*[\u0900-\u097F]+)*|[^\u0900-\u097F]+/g)
    ?.map((part) => part.trim())
    .filter(Boolean) || [];
}

export function speakWithIndianVoices(text, { onComplete, onError } = {}) {
  const segments = splitByScript(text);
  let segmentIndex = 0;

  const speakNext = () => {
    if (segmentIndex >= segments.length) {
      onComplete?.();
      return;
    }

    const utterance = createIndianSpeechUtterance(segments[segmentIndex]);
    utterance.onend = () => {
      segmentIndex += 1;
      speakNext();
    };
    utterance.onerror = (event) => onError?.(event);
    window.speechSynthesis.speak(utterance);
  };

  speakNext();
}
